import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

export default function Checkbox(props) {
  const {
    label,
    checked = false,
    onChange = () => {},
    disabled = false,
    wrapClassNames
  } = props;

  return (
    <div className={cn('move-checkbox', wrapClassNames)}>
      <label className="gap-3">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <span className={cn('move-checkbox__checkmark', { disabled })} />
        <span className={cn('move-checkbox__value label-medium text-primary text-start', { disabled, '!font-medium': !checked, '!font-semibold': checked })}>
          {label}
        </span>
      </label>
    </div>
  );
}

Checkbox.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  onChange: PropTypes.func,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  wrapClassNames: PropTypes.string,
};
